import { render, staticRenderFns } from "./VerticalNavMenuItemsStructure.vue?vue&type=template&id=4f1e10c4"
import script from "./VerticalNavMenuItemsStructure.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuItemsStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports